import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[avanoTabBody]'
})
export class TabBodyDirective {
  constructor(public templateRef: TemplateRef<unknown>) {}
}
